import { Box, BoxProps } from '@air/zephyr';
import Image from 'next/image';

import { MediaData } from '~/lib/contentful/custom-types';
import { SECTION_CMS_LINK_CLASS_NAME } from '~/old-marketing/components/sections/Section';

export const WorthlessStudiosFreeFilmsSectionTemplateAsset = ({
  file,
  isPreview,
  tx,
}: MediaData & Pick<BoxProps, 'tx'> & { isPreview?: boolean }) => {
  return (
    <Box
      className={isPreview ? SECTION_CMS_LINK_CLASS_NAME : ''}
      tx={{
        position: 'relative',
        maxWidth: [274, '25vw'],
        mt: [90, -70],
        transform: ['rotate(8deg)', 'none'],

        '> span': {
          display: 'block !important',
          borderRadius: 4,
        },

        ...tx,
      }}
    >
      <Box
        tx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          border: '1px solid',
          borderColor: 'pigeon800',
          borderRadius: 4,
          transform: 'translate(-17.8%, -13.4%)',
        }}
      />
      <Box
        tx={{
          position: 'absolute',
          backgroundColor: ['pigeon050', 'white'],
          width: '100%',
          height: '100%',
          border: '1px solid',
          borderColor: 'pigeon800',
          borderRadius: 4,
          transform: 'translate(-8.9%, -6.7%)',
        }}
      />
      <Image height={file.details.image.height} src={`http:${file.url}`} width={file.details.image.width} />
    </Box>
  );
};
